module.exports = __webpack_public_path__ + "images/e8afe2d8139ffbeff527746fd800670c.svg";